"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Object = _interopRequireDefault(require("../Object.js"));

var _Property = _interopRequireDefault(require("./Property.js"));

var _util = require("../util.js");

var _asserts = require("../asserts.js");

var _obj = require("../obj.js");

var _math = require("../math.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
/**
 * @module ol/layer/Base
 */


/**
 * A css color, or a function called with a view resolution returning a css color.
 *
 * @typedef {string|function(number):string} BackgroundColor
 * @api
 */

/**
 * @typedef {import("../ObjectEventType").Types|'change:extent'|'change:maxResolution'|'change:maxZoom'|
 *    'change:minResolution'|'change:minZoom'|'change:opacity'|'change:visible'|'change:zIndex'} BaseLayerObjectEventTypes
 */

/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<BaseLayerObjectEventTypes, import("../Object").ObjectEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|BaseLayerObjectEventTypes, Return>} BaseLayerOnSignature
 */

/**
 * @typedef {Object} Options
 * @property {string} [className='ol-layer'] A CSS class name to set to the layer element.
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {BackgroundColor} [background] Background color for the layer. If not specified, no background
 * will be rendered.
 * @property {Object<string, *>} [properties] Arbitrary observable properties. Can be accessed with `#get()` and `#set()`.
 */

/**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Note that with {@link module:ol/layer/Base~BaseLayer} and all its subclasses, any property set in
 * the options is set as a {@link module:ol/Object~BaseObject} property on the layer object, so
 * is observable, and has get/set accessors.
 *
 * @api
 */
var BaseLayer =
/** @class */
function (_super) {
  __extends(BaseLayer, _super);
  /**
   * @param {Options} options Layer options.
   */


  function BaseLayer(options) {
    var _this = _super.call(this) || this;
    /***
     * @type {BaseLayerOnSignature<import("../events").EventsKey>}
     */


    _this.on;
    /***
     * @type {BaseLayerOnSignature<import("../events").EventsKey>}
     */

    _this.once;
    /***
     * @type {BaseLayerOnSignature<void>}
     */

    _this.un;
    /**
     * @type {BackgroundColor|false}
     * @private
     */

    _this.background_ = options.background;
    /**
     * @type {Object<string, *>}
     */

    var properties = (0, _obj.assign)({}, options);

    if (_typeof(options.properties) === 'object') {
      delete properties.properties;
      (0, _obj.assign)(properties, options.properties);
    }

    properties[_Property["default"].OPACITY] = options.opacity !== undefined ? options.opacity : 1;
    (0, _asserts.assert)(typeof properties[_Property["default"].OPACITY] === 'number', 64); // Layer opacity must be a number

    properties[_Property["default"].VISIBLE] = options.visible !== undefined ? options.visible : true;
    properties[_Property["default"].Z_INDEX] = options.zIndex;
    properties[_Property["default"].MAX_RESOLUTION] = options.maxResolution !== undefined ? options.maxResolution : Infinity;
    properties[_Property["default"].MIN_RESOLUTION] = options.minResolution !== undefined ? options.minResolution : 0;
    properties[_Property["default"].MIN_ZOOM] = options.minZoom !== undefined ? options.minZoom : -Infinity;
    properties[_Property["default"].MAX_ZOOM] = options.maxZoom !== undefined ? options.maxZoom : Infinity;
    /**
     * @type {string}
     * @private
     */

    _this.className_ = properties.className !== undefined ? properties.className : 'ol-layer';
    delete properties.className;

    _this.setProperties(properties);
    /**
     * @type {import("./Layer.js").State}
     * @private
     */


    _this.state_ = null;
    return _this;
  }
  /**
   * Get the background for this layer.
   * @return {BackgroundColor|false} Layer background.
   */


  BaseLayer.prototype.getBackground = function () {
    return this.background_;
  };
  /**
   * @return {string} CSS class name.
   */


  BaseLayer.prototype.getClassName = function () {
    return this.className_;
  };
  /**
   * This method is not meant to be called by layers or layer renderers because the state
   * is incorrect if the layer is included in a layer group.
   *
   * @param {boolean} [opt_managed] Layer is managed.
   * @return {import("./Layer.js").State} Layer state.
   */


  BaseLayer.prototype.getLayerState = function (opt_managed) {
    /** @type {import("./Layer.js").State} */
    var state = this.state_ ||
    /** @type {?} */
    {
      layer: this,
      managed: opt_managed === undefined ? true : opt_managed
    };
    var zIndex = this.getZIndex();
    state.opacity = (0, _math.clamp)(Math.round(this.getOpacity() * 100) / 100, 0, 1);
    state.visible = this.getVisible();
    state.extent = this.getExtent();
    state.zIndex = zIndex === undefined && !state.managed ? Infinity : zIndex;
    state.maxResolution = this.getMaxResolution();
    state.minResolution = Math.max(this.getMinResolution(), 0);
    state.minZoom = this.getMinZoom();
    state.maxZoom = this.getMaxZoom();
    this.state_ = state;
    return state;
  };
  /**
   * @abstract
   * @param {Array<import("./Layer.js").default>} [opt_array] Array of layers (to be
   *     modified in place).
   * @return {Array<import("./Layer.js").default>} Array of layers.
   */


  BaseLayer.prototype.getLayersArray = function (opt_array) {
    return (0, _util["abstract"])();
  };
  /**
   * @abstract
   * @param {Array<import("./Layer.js").State>} [opt_states] Optional list of layer
   *     states (to be modified in place).
   * @return {Array<import("./Layer.js").State>} List of layer states.
   */


  BaseLayer.prototype.getLayerStatesArray = function (opt_states) {
    return (0, _util["abstract"])();
  };
  /**
   * Return the {@link module:ol/extent~Extent extent} of the layer or `undefined` if it
   * will be visible regardless of extent.
   * @return {import("../extent.js").Extent|undefined} The layer extent.
   * @observable
   * @api
   */


  BaseLayer.prototype.getExtent = function () {
    return (
      /** @type {import("../extent.js").Extent|undefined} */
      this.get(_Property["default"].EXTENT)
    );
  };
  /**
   * Return the maximum resolution of the layer.
   * @return {number} The maximum resolution of the layer.
   * @observable
   * @api
   */


  BaseLayer.prototype.getMaxResolution = function () {
    return (
      /** @type {number} */
      this.get(_Property["default"].MAX_RESOLUTION)
    );
  };
  /**
   * Return the minimum resolution of the layer.
   * @return {number} The minimum resolution of the layer.
   * @observable
   * @api
   */


  BaseLayer.prototype.getMinResolution = function () {
    return (
      /** @type {number} */
      this.get(_Property["default"].MIN_RESOLUTION)
    );
  };
  /**
   * Return the minimum zoom level of the layer.
   * @return {number} The minimum zoom level of the layer.
   * @observable
   * @api
   */


  BaseLayer.prototype.getMinZoom = function () {
    return (
      /** @type {number} */
      this.get(_Property["default"].MIN_ZOOM)
    );
  };
  /**
   * Return the maximum zoom level of the layer.
   * @return {number} The maximum zoom level of the layer.
   * @observable
   * @api
   */


  BaseLayer.prototype.getMaxZoom = function () {
    return (
      /** @type {number} */
      this.get(_Property["default"].MAX_ZOOM)
    );
  };
  /**
   * Return the opacity of the layer (between 0 and 1).
   * @return {number} The opacity of the layer.
   * @observable
   * @api
   */


  BaseLayer.prototype.getOpacity = function () {
    return (
      /** @type {number} */
      this.get(_Property["default"].OPACITY)
    );
  };
  /**
   * @abstract
   * @return {import("../source/State.js").default} Source state.
   */


  BaseLayer.prototype.getSourceState = function () {
    return (0, _util["abstract"])();
  };
  /**
   * Return the visibility of the layer (`true` or `false`).
   * @return {boolean} The visibility of the layer.
   * @observable
   * @api
   */


  BaseLayer.prototype.getVisible = function () {
    return (
      /** @type {boolean} */
      this.get(_Property["default"].VISIBLE)
    );
  };
  /**
   * Return the Z-index of the layer, which is used to order layers before
   * rendering. The default Z-index is 0.
   * @return {number} The Z-index of the layer.
   * @observable
   * @api
   */


  BaseLayer.prototype.getZIndex = function () {
    return (
      /** @type {number} */
      this.get(_Property["default"].Z_INDEX)
    );
  };
  /**
   * Sets the background color.
   * @param {BackgroundColor} [opt_background] Background color.
   */


  BaseLayer.prototype.setBackground = function (opt_background) {
    this.background_ = opt_background;
    this.changed();
  };
  /**
   * Set the extent at which the layer is visible.  If `undefined`, the layer
   * will be visible at all extents.
   * @param {import("../extent.js").Extent|undefined} extent The extent of the layer.
   * @observable
   * @api
   */


  BaseLayer.prototype.setExtent = function (extent) {
    this.set(_Property["default"].EXTENT, extent);
  };
  /**
   * Set the maximum resolution at which the layer is visible.
   * @param {number} maxResolution The maximum resolution of the layer.
   * @observable
   * @api
   */


  BaseLayer.prototype.setMaxResolution = function (maxResolution) {
    this.set(_Property["default"].MAX_RESOLUTION, maxResolution);
  };
  /**
   * Set the minimum resolution at which the layer is visible.
   * @param {number} minResolution The minimum resolution of the layer.
   * @observable
   * @api
   */


  BaseLayer.prototype.setMinResolution = function (minResolution) {
    this.set(_Property["default"].MIN_RESOLUTION, minResolution);
  };
  /**
   * Set the maximum zoom (exclusive) at which the layer is visible.
   * Note that the zoom levels for layer visibility are based on the
   * view zoom level, which may be different from a tile source zoom level.
   * @param {number} maxZoom The maximum zoom of the layer.
   * @observable
   * @api
   */


  BaseLayer.prototype.setMaxZoom = function (maxZoom) {
    this.set(_Property["default"].MAX_ZOOM, maxZoom);
  };
  /**
   * Set the minimum zoom (inclusive) at which the layer is visible.
   * Note that the zoom levels for layer visibility are based on the
   * view zoom level, which may be different from a tile source zoom level.
   * @param {number} minZoom The minimum zoom of the layer.
   * @observable
   * @api
   */


  BaseLayer.prototype.setMinZoom = function (minZoom) {
    this.set(_Property["default"].MIN_ZOOM, minZoom);
  };
  /**
   * Set the opacity of the layer, allowed values range from 0 to 1.
   * @param {number} opacity The opacity of the layer.
   * @observable
   * @api
   */


  BaseLayer.prototype.setOpacity = function (opacity) {
    (0, _asserts.assert)(typeof opacity === 'number', 64); // Layer opacity must be a number

    this.set(_Property["default"].OPACITY, opacity);
  };
  /**
   * Set the visibility of the layer (`true` or `false`).
   * @param {boolean} visible The visibility of the layer.
   * @observable
   * @api
   */


  BaseLayer.prototype.setVisible = function (visible) {
    this.set(_Property["default"].VISIBLE, visible);
  };
  /**
   * Set Z-index of the layer, which is used to order layers before rendering.
   * The default Z-index is 0.
   * @param {number} zindex The z-index of the layer.
   * @observable
   * @api
   */


  BaseLayer.prototype.setZIndex = function (zindex) {
    this.set(_Property["default"].Z_INDEX, zindex);
  };
  /**
   * Clean up.
   */


  BaseLayer.prototype.disposeInternal = function () {
    if (this.state_) {
      this.state_.layer = null;
      this.state_ = null;
    }

    _super.prototype.disposeInternal.call(this);
  };

  return BaseLayer;
}(_Object["default"]);

var _default = BaseLayer;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUdBOztBQUNBOztBQUNBOztBQUNBOztBQUNBOztBQUNBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFSQTs7Ozs7QUFVQTs7Ozs7OztBQU9BOzs7OztBQUtBOzs7Ozs7O0FBT0E7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQXdCQTs7Ozs7Ozs7OztBQVVBO0FBQUE7QUFBQTtFQUF3QkE7RUFDdEI7Ozs7O0VBR0EsbUJBQVlDLE9BQVosRUFBbUI7SUFBbkIsWUFDRUMscUJBQU8sSUFEVDtJQUdFOzs7OztJQUdBQyxLQUFJLENBQUNDLEVBQUw7SUFFQTs7OztJQUdBRCxLQUFJLENBQUNFLElBQUw7SUFFQTs7OztJQUdBRixLQUFJLENBQUNHLEVBQUw7SUFFQTs7Ozs7SUFJQUgsS0FBSSxDQUFDSSxXQUFMLEdBQW1CTixPQUFPLENBQUNPLFVBQTNCO0lBRUE7Ozs7SUFHQSxJQUFNQyxVQUFVLEdBQUcsaUJBQU8sRUFBUCxFQUFXUixPQUFYLENBQW5COztJQUNBLElBQUksUUFBT0EsT0FBTyxDQUFDUSxVQUFmLE1BQThCLFFBQWxDLEVBQTRDO01BQzFDLE9BQU9BLFVBQVUsQ0FBQ0EsVUFBbEI7TUFDQSxpQkFBT0EsVUFBUCxFQUFtQlIsT0FBTyxDQUFDUSxVQUEzQjtJQUNEOztJQUVEQSxVQUFVLENBQUNDLHFCQUFjQyxPQUFmLENBQVYsR0FDRVYsT0FBTyxDQUFDVyxPQUFSLEtBQW9CQyxTQUFwQixHQUFnQ1osT0FBTyxDQUFDVyxPQUF4QyxHQUFrRCxDQURwRDtJQUVBLHFCQUFPLE9BQU9ILFVBQVUsQ0FBQ0MscUJBQWNDLE9BQWYsQ0FBakIsS0FBNkMsUUFBcEQsRUFBOEQsRUFBOUQsRUFuQ2lCLENBbUNrRDs7SUFFbkVGLFVBQVUsQ0FBQ0MscUJBQWNJLE9BQWYsQ0FBVixHQUNFYixPQUFPLENBQUNjLE9BQVIsS0FBb0JGLFNBQXBCLEdBQWdDWixPQUFPLENBQUNjLE9BQXhDLEdBQWtELElBRHBEO0lBRUFOLFVBQVUsQ0FBQ0MscUJBQWNNLE9BQWYsQ0FBVixHQUFvQ2YsT0FBTyxDQUFDZ0IsTUFBNUM7SUFDQVIsVUFBVSxDQUFDQyxxQkFBY1EsY0FBZixDQUFWLEdBQ0VqQixPQUFPLENBQUNrQixhQUFSLEtBQTBCTixTQUExQixHQUFzQ1osT0FBTyxDQUFDa0IsYUFBOUMsR0FBOERDLFFBRGhFO0lBRUFYLFVBQVUsQ0FBQ0MscUJBQWNXLGNBQWYsQ0FBVixHQUNFcEIsT0FBTyxDQUFDcUIsYUFBUixLQUEwQlQsU0FBMUIsR0FBc0NaLE9BQU8sQ0FBQ3FCLGFBQTlDLEdBQThELENBRGhFO0lBRUFiLFVBQVUsQ0FBQ0MscUJBQWNhLFFBQWYsQ0FBVixHQUNFdEIsT0FBTyxDQUFDdUIsT0FBUixLQUFvQlgsU0FBcEIsR0FBZ0NaLE9BQU8sQ0FBQ3VCLE9BQXhDLEdBQWtELENBQUNKLFFBRHJEO0lBRUFYLFVBQVUsQ0FBQ0MscUJBQWNlLFFBQWYsQ0FBVixHQUNFeEIsT0FBTyxDQUFDeUIsT0FBUixLQUFvQmIsU0FBcEIsR0FBZ0NaLE9BQU8sQ0FBQ3lCLE9BQXhDLEdBQWtETixRQURwRDtJQUdBOzs7OztJQUlBakIsS0FBSSxDQUFDd0IsVUFBTCxHQUNFbEIsVUFBVSxDQUFDbUIsU0FBWCxLQUF5QmYsU0FBekIsR0FBcUNKLFVBQVUsQ0FBQ21CLFNBQWhELEdBQTRELFVBRDlEO0lBRUEsT0FBT25CLFVBQVUsQ0FBQ21CLFNBQWxCOztJQUVBekIsS0FBSSxDQUFDMEIsYUFBTCxDQUFtQnBCLFVBQW5CO0lBRUE7Ozs7OztJQUlBTixLQUFJLENBQUMyQixNQUFMLEdBQWMsSUFBZDs7RUFDRDtFQUVEOzs7Ozs7RUFJQUM7SUFDRSxPQUFPLEtBQUt4QixXQUFaO0VBQ0QsQ0FGRDtFQUlBOzs7OztFQUdBd0I7SUFDRSxPQUFPLEtBQUtKLFVBQVo7RUFDRCxDQUZEO0VBSUE7Ozs7Ozs7OztFQU9BSSw4Q0FBY0MsV0FBZCxFQUF5QjtJQUN2QjtJQUNBLElBQU1DLEtBQUssR0FDVCxLQUFLSCxNQUFMO0lBQ0E7SUFBa0I7TUFDaEJJLEtBQUssRUFBRSxJQURTO01BRWhCQyxPQUFPLEVBQUVILFdBQVcsS0FBS25CLFNBQWhCLEdBQTRCLElBQTVCLEdBQW1DbUI7SUFGNUIsQ0FGcEI7SUFNQSxJQUFNZixNQUFNLEdBQUcsS0FBS21CLFNBQUwsRUFBZjtJQUNBSCxLQUFLLENBQUNyQixPQUFOLEdBQWdCLGlCQUFNeUIsSUFBSSxDQUFDQyxLQUFMLENBQVcsS0FBS0MsVUFBTCxLQUFvQixHQUEvQixJQUFzQyxHQUE1QyxFQUFpRCxDQUFqRCxFQUFvRCxDQUFwRCxDQUFoQjtJQUNBTixLQUFLLENBQUNsQixPQUFOLEdBQWdCLEtBQUt5QixVQUFMLEVBQWhCO0lBQ0FQLEtBQUssQ0FBQ1EsTUFBTixHQUFlLEtBQUtDLFNBQUwsRUFBZjtJQUNBVCxLQUFLLENBQUNoQixNQUFOLEdBQWVBLE1BQU0sS0FBS0osU0FBWCxJQUF3QixDQUFDb0IsS0FBSyxDQUFDRSxPQUEvQixHQUF5Q2YsUUFBekMsR0FBb0RILE1BQW5FO0lBQ0FnQixLQUFLLENBQUNkLGFBQU4sR0FBc0IsS0FBS3dCLGdCQUFMLEVBQXRCO0lBQ0FWLEtBQUssQ0FBQ1gsYUFBTixHQUFzQmUsSUFBSSxDQUFDTyxHQUFMLENBQVMsS0FBS0MsZ0JBQUwsRUFBVCxFQUFrQyxDQUFsQyxDQUF0QjtJQUNBWixLQUFLLENBQUNULE9BQU4sR0FBZ0IsS0FBS3NCLFVBQUwsRUFBaEI7SUFDQWIsS0FBSyxDQUFDUCxPQUFOLEdBQWdCLEtBQUtxQixVQUFMLEVBQWhCO0lBQ0EsS0FBS2pCLE1BQUwsR0FBY0csS0FBZDtJQUVBLE9BQU9BLEtBQVA7RUFDRCxDQXBCRDtFQXNCQTs7Ozs7Ozs7RUFNQUYsK0NBQWVpQixTQUFmLEVBQXdCO0lBQ3RCLE9BQU8sd0JBQVA7RUFDRCxDQUZEO0VBSUE7Ozs7Ozs7O0VBTUFqQixvREFBb0JrQixVQUFwQixFQUE4QjtJQUM1QixPQUFPLHdCQUFQO0VBQ0QsQ0FGRDtFQUlBOzs7Ozs7Ozs7RUFPQWxCO0lBQ0U7TUFBTztNQUNMLEtBQUttQixHQUFMLENBQVN4QyxxQkFBY3lDLE1BQXZCO0lBREY7RUFHRCxDQUpEO0VBTUE7Ozs7Ozs7O0VBTUFwQjtJQUNFO01BQU87TUFBdUIsS0FBS21CLEdBQUwsQ0FBU3hDLHFCQUFjUSxjQUF2QjtJQUE5QjtFQUNELENBRkQ7RUFJQTs7Ozs7Ozs7RUFNQWE7SUFDRTtNQUFPO01BQXVCLEtBQUttQixHQUFMLENBQVN4QyxxQkFBY1csY0FBdkI7SUFBOUI7RUFDRCxDQUZEO0VBSUE7Ozs7Ozs7O0VBTUFVO0lBQ0U7TUFBTztNQUF1QixLQUFLbUIsR0FBTCxDQUFTeEMscUJBQWNhLFFBQXZCO0lBQTlCO0VBQ0QsQ0FGRDtFQUlBOzs7Ozs7OztFQU1BUTtJQUNFO01BQU87TUFBdUIsS0FBS21CLEdBQUwsQ0FBU3hDLHFCQUFjZSxRQUF2QjtJQUE5QjtFQUNELENBRkQ7RUFJQTs7Ozs7Ozs7RUFNQU07SUFDRTtNQUFPO01BQXVCLEtBQUttQixHQUFMLENBQVN4QyxxQkFBY0MsT0FBdkI7SUFBOUI7RUFDRCxDQUZEO0VBSUE7Ozs7OztFQUlBb0I7SUFDRSxPQUFPLHdCQUFQO0VBQ0QsQ0FGRDtFQUlBOzs7Ozs7OztFQU1BQTtJQUNFO01BQU87TUFBd0IsS0FBS21CLEdBQUwsQ0FBU3hDLHFCQUFjSSxPQUF2QjtJQUEvQjtFQUNELENBRkQ7RUFJQTs7Ozs7Ozs7O0VBT0FpQjtJQUNFO01BQU87TUFBdUIsS0FBS21CLEdBQUwsQ0FBU3hDLHFCQUFjTSxPQUF2QjtJQUE5QjtFQUNELENBRkQ7RUFJQTs7Ozs7O0VBSUFlLDhDQUFjcUIsY0FBZCxFQUE0QjtJQUMxQixLQUFLN0MsV0FBTCxHQUFtQjZDLGNBQW5CO0lBQ0EsS0FBS0MsT0FBTDtFQUNELENBSEQ7RUFLQTs7Ozs7Ozs7O0VBT0F0QiwwQ0FBVVUsTUFBVixFQUFnQjtJQUNkLEtBQUthLEdBQUwsQ0FBUzVDLHFCQUFjeUMsTUFBdkIsRUFBK0JWLE1BQS9CO0VBQ0QsQ0FGRDtFQUlBOzs7Ozs7OztFQU1BVixpREFBaUJaLGFBQWpCLEVBQThCO0lBQzVCLEtBQUttQyxHQUFMLENBQVM1QyxxQkFBY1EsY0FBdkIsRUFBdUNDLGFBQXZDO0VBQ0QsQ0FGRDtFQUlBOzs7Ozs7OztFQU1BWSxpREFBaUJULGFBQWpCLEVBQThCO0lBQzVCLEtBQUtnQyxHQUFMLENBQVM1QyxxQkFBY1csY0FBdkIsRUFBdUNDLGFBQXZDO0VBQ0QsQ0FGRDtFQUlBOzs7Ozs7Ozs7O0VBUUFTLDJDQUFXTCxPQUFYLEVBQWtCO0lBQ2hCLEtBQUs0QixHQUFMLENBQVM1QyxxQkFBY2UsUUFBdkIsRUFBaUNDLE9BQWpDO0VBQ0QsQ0FGRDtFQUlBOzs7Ozs7Ozs7O0VBUUFLLDJDQUFXUCxPQUFYLEVBQWtCO0lBQ2hCLEtBQUs4QixHQUFMLENBQVM1QyxxQkFBY2EsUUFBdkIsRUFBaUNDLE9BQWpDO0VBQ0QsQ0FGRDtFQUlBOzs7Ozs7OztFQU1BTywyQ0FBV25CLE9BQVgsRUFBa0I7SUFDaEIscUJBQU8sT0FBT0EsT0FBUCxLQUFtQixRQUExQixFQUFvQyxFQUFwQyxFQURnQixDQUN5Qjs7SUFDekMsS0FBSzBDLEdBQUwsQ0FBUzVDLHFCQUFjQyxPQUF2QixFQUFnQ0MsT0FBaEM7RUFDRCxDQUhEO0VBS0E7Ozs7Ozs7O0VBTUFtQiwyQ0FBV2hCLE9BQVgsRUFBa0I7SUFDaEIsS0FBS3VDLEdBQUwsQ0FBUzVDLHFCQUFjSSxPQUF2QixFQUFnQ0MsT0FBaEM7RUFDRCxDQUZEO0VBSUE7Ozs7Ozs7OztFQU9BZ0IsMENBQVV3QixNQUFWLEVBQWdCO0lBQ2QsS0FBS0QsR0FBTCxDQUFTNUMscUJBQWNNLE9BQXZCLEVBQWdDdUMsTUFBaEM7RUFDRCxDQUZEO0VBSUE7Ozs7O0VBR0F4QjtJQUNFLElBQUksS0FBS0QsTUFBVCxFQUFpQjtNQUNmLEtBQUtBLE1BQUwsQ0FBWUksS0FBWixHQUFvQixJQUFwQjtNQUNBLEtBQUtKLE1BQUwsR0FBYyxJQUFkO0lBQ0Q7O0lBQ0Q1QixpQkFBTXNELGVBQU4sQ0FBcUJDLElBQXJCLENBQXFCLElBQXJCO0VBQ0QsQ0FORDs7RUFPRjtBQUFDLENBNVVELENBQXdCQyxrQkFBeEI7O2VBOFVlM0IsUyIsIm5hbWVzIjpbIl9fZXh0ZW5kcyIsIm9wdGlvbnMiLCJfc3VwZXIiLCJfdGhpcyIsIm9uIiwib25jZSIsInVuIiwiYmFja2dyb3VuZF8iLCJiYWNrZ3JvdW5kIiwicHJvcGVydGllcyIsIkxheWVyUHJvcGVydHkiLCJPUEFDSVRZIiwib3BhY2l0eSIsInVuZGVmaW5lZCIsIlZJU0lCTEUiLCJ2aXNpYmxlIiwiWl9JTkRFWCIsInpJbmRleCIsIk1BWF9SRVNPTFVUSU9OIiwibWF4UmVzb2x1dGlvbiIsIkluZmluaXR5IiwiTUlOX1JFU09MVVRJT04iLCJtaW5SZXNvbHV0aW9uIiwiTUlOX1pPT00iLCJtaW5ab29tIiwiTUFYX1pPT00iLCJtYXhab29tIiwiY2xhc3NOYW1lXyIsImNsYXNzTmFtZSIsInNldFByb3BlcnRpZXMiLCJzdGF0ZV8iLCJCYXNlTGF5ZXIiLCJvcHRfbWFuYWdlZCIsInN0YXRlIiwibGF5ZXIiLCJtYW5hZ2VkIiwiZ2V0WkluZGV4IiwiTWF0aCIsInJvdW5kIiwiZ2V0T3BhY2l0eSIsImdldFZpc2libGUiLCJleHRlbnQiLCJnZXRFeHRlbnQiLCJnZXRNYXhSZXNvbHV0aW9uIiwibWF4IiwiZ2V0TWluUmVzb2x1dGlvbiIsImdldE1pblpvb20iLCJnZXRNYXhab29tIiwib3B0X2FycmF5Iiwib3B0X3N0YXRlcyIsImdldCIsIkVYVEVOVCIsIm9wdF9iYWNrZ3JvdW5kIiwiY2hhbmdlZCIsInNldCIsInppbmRleCIsImRpc3Bvc2VJbnRlcm5hbCIsImNhbGwiLCJCYXNlT2JqZWN0Il0sInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9sYXllci9CYXNlLmpzIl0sInNvdXJjZXNDb250ZW50IjpbbnVsbF19